import { ReactNode, useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

export const DataFoundationEvents = {
	ProvisioningScreenViewed: {
		eventType: 'screen',
		name: 'provisioningScreen',
	},
	TeamChoiceScreenViewed: {
		eventType: 'screen',
		name: 'teamChoiceScreen',
	},
	TemplateChoiceScreenViewed: {
		eventType: 'screen',
		name: 'templateChoiceScreen',
	},
	JTBDScreenViewed: {
		eventType: 'screen',
		name: 'jtbdScreen',
	},
	ProjectLandingSelectionScreenViewed: {
		eventType: 'screen',
		name: 'projectLandingSelectionScreen',
	},
	TryIntent: {
		eventType: 'track',
		action: 'interacted',
		actionSubject: 'tryIntentComponent',
	},
	ProductNavigationInitialized: {
		eventType: 'track',
		action: 'initialized',
		actionSubject: 'productNavigation',
	},
} as const;

type DataFoundationEventOptionMap = typeof DataFoundationEvents;

export type DataFoundationEventOption = keyof DataFoundationEventOptionMap;

export const getDataFoundationEvent = (dataFoundationsEventOption: DataFoundationEventOption) => {
	return DataFoundationEvents[dataFoundationsEventOption];
};

export type DataFoundationsWrapperProps = {
	dataFoundationsEventOption: DataFoundationEventOption;
	attributes?: object;
	waitForAttributes?: boolean;
	children: ReactNode;
};

export const DataFoundationsWrapper = ({
	dataFoundationsEventOption,
	attributes,
	waitForAttributes,
	children,
}: DataFoundationsWrapperProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const analyticsClient = useAnalyticsEvents();

	useEffect(() => {
		if (!analyticsClient || waitForAttributes) {
			return;
		}

		createAnalyticsEvent({
			...getDataFoundationEvent(dataFoundationsEventOption),
			attributes,
		}).fire();
	}, [
		createAnalyticsEvent,
		dataFoundationsEventOption,
		attributes,
		analyticsClient,
		waitForAttributes,
	]);

	return children;
};
